import { X, FileText } from 'lucide-react';

export function NotePickerModal({ isOpen, notes, onSelect, onClose }) {
  if (!isOpen || !notes?.length) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-sm shadow-xl">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="font-semibold text-gray-900">Select Note to Continue</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        <div className="max-h-64 overflow-y-auto">
          {notes.map((note) => (
            <button
              key={note.id}
              onClick={() => onSelect(note.id)}
              className="w-full text-left px-4 py-3 hover:bg-gray-50 border-b last:border-b-0 transition-colors"
            >
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-gray-400 shrink-0" />
                <div className="min-w-0">
                  <p className="font-medium text-sm text-gray-900 truncate">
                    {note.note_type ? note.note_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'SOAP Note'}
                  </p>
                  <p className="text-xs text-gray-500">
                    {note.provider?.first_name} {note.provider?.last_name}
                    {note.created_at && ` — ${new Date(note.created_at).toLocaleDateString()}`}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
